import React, { useState } from 'react'
// import AddSettlement from './components/AddSettlement'
import { withTranslation } from 'react-i18next'
import BankDetails from './components/BankDetails'
// import { SettlementBankValidation } from 'pages/Settings/validation'
import useSWR from 'swr'
import SettlementTable from './components/SettlementTable'
import { SettlementContext } from './settlementContext'


export default withTranslation()(function BankSettlement({ t }) {
  const { data: settlement_bank } = useSWR('settings/settlement-banks')
  const [edit, setEdit] = useState({ editId: null, editState: false })

  const offline = { data: [
    { account_name: 'This is the account name', bank_name: 'Ecobank Nigeria', account_number: '87234687324892' },
    { account_name: 'This is the account test 1', bank_name: 'First Nigeria', account_number: '87234687324892' },
    { account_name: 'This is the account test 2', bank_name: 'Access Nigeria', account_number: '87234687324892' },
  ] }
  // dispatch(showModal({
  //   title: t('settings.bank_settlement.title'),
  //   content: AddSettlement,
  //   url: 'settings/settlement-banks',
  //   validation: SettlementBankValidation,
  //   values: !settlement_bank?.data ? {
  //     bank_name: '',
  //     account_name: '',
  //     account_no: ''
  //   } : {
  //     bank_name: settlement_bank?.data.bank_name,
  //     account_name: settlement_bank?.data.account_name,
  //     account_no: settlement_bank?.data.account_no
  //   },
  //   method: !settlement_bank?.data ? 'post' : 'put',
  //   formClass: 'w-11/12 md:w-[390px]',
  //   successMsg: settlement_bank?.data ? t('settings.bank_settlement.modified') : t('settings.bank_settlement.created')
  // }))

  return (
    <SettlementContext.Provider value={{ edit, setEdit }}>
      <SettlementTable settlement_bank={offline} online={settlement_bank}/>
      <BankDetails settlement_bank={offline.data[edit.editId]} edit={edit.editState} />
    </SettlementContext.Provider>
  )
})